import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';
import ProductTableForMenu from '../components/ProductTableForMenu';

export default function MenuProductSelect(props) {
  const { showSelectProduct, setShowSelectProduct, productAddHandler } = props;
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  return (
    <Modal show={showSelectProduct} onHide={() => setShowSelectProduct(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          <span className="text-secondary">{'Ürün Seç'}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ minHeight: isTabletOrMobile ? '100vh' : '50vh' }}>
        <ProductTableForMenu
          setShowSelectProduct={setShowSelectProduct}
          productAddHandler={productAddHandler}
        ></ProductTableForMenu>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={() => {
            setShowSelectProduct(false);
          }}
        >
          Kapat
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
